import React, { useMemo } from 'react';
import Alert from '@mui/material/Alert';

import { PlaybookVariable } from 'src/services/api/playbooks/use-playbook-variables';
import { getVariablesFromMessage } from 'src/common/playbook-variables/playbook-variable-utils';

type Props = {
    message: string;
}

export default function PlaybookWarning({
    message,
}: Props) {
    const warning = useMemo(() => {
        const foundVars = getVariablesFromMessage(message);

        const isPropertyAddressUsed = foundVars.includes(PlaybookVariable.PropertyAddress);
        const isTourLinkUsed = foundVars.includes(PlaybookVariable.PropertyTourLink);
        const isApplicationLinkUsed = foundVars.includes(PlaybookVariable.PropertyApplicationLink);

        if (!(isPropertyAddressUsed || isTourLinkUsed || isApplicationLinkUsed)) {
            return;
        }

        let _warning = 'To receive this message, the lead has to have a property assigned.';

        if (isTourLinkUsed && isApplicationLinkUsed) {
            _warning += ' Also, the associated property has to have a tour link and an application link.';
        } else if (isTourLinkUsed) {
            _warning += ' Also, the associated property has to have a tour link.';
        } else if (isApplicationLinkUsed) {
            _warning += ' Also, the associated property has to have an application link.';
        }

        return _warning;
    }, [message]);

    if (!warning) {
        return null;
    }

    return (
        <Alert severity="warning">
            {warning}
        </Alert>
    );
}
